<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <v-row v-if="enableTable">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              id="idTable"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
              >
                <thead>
                  <tr>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      Vendedor
                    </th>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      Clientes Ativos
                    </th>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      Positivados
                    </th>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      % Postivação
                    </th>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      Sem Compra
                    </th>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      Ticket Médio
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-for="item in dados"
                  :key="item.id"
                >
                  <tr>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: left;"
                    >
                      {{ item.vendedor }}
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: right;"
                    >
                      {{ item.cliente }}
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: right;"
                    >
                      {{ item.positivados }}
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: right;"
                    >
                      {{ item.porcentagem }}
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: right;"
                    >
                      {{ item.semCompra }}
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: right;"
                    >
                      {{ item.ticket }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <router-link
              id="linkDetalhe"
              to="/analise-vendas/detalhe-analise-vendas"
              class="text-center"
              :style="styleObject"
            >
              <div
                id="linkDetalheAnaliseVendas"
                class="text-center"
              >
                <v-icon
                  id="iconLinkAnaliseVendas"
                  class="text-center"
                >
                  mdi-chevron-double-down
                </v-icon><br>
              </div>
            </router-link>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../../services/comercialpersonalizacao'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'DashboardTableCoberturaVendedor',
    emits: ['enableBtnPrint'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectSupervisor: [],
      headers: [
        { text: 'Vendedor', value: 'vendedor', class: 'black--text title' },
        { text: 'Clientes Ativos', value: 'cliente', align: 'right', class: 'black--text title' },
        { text: 'Positivados', value: 'positivados', align: 'right', class: 'black--text title' },
        { text: '% Postivação', value: 'porcentagem', align: 'right', class: 'black--text title' },
        { text: 'Sem Compra', value: 'semCompra', align: 'right', class: 'black--text title' },
        { text: 'Ticket Médio', value: 'ticket', align: 'right', class: 'black--text title' },
      ],
      dados: [],
      minWidth: 1380,
      width: window.innerWidth,
      enableTable: false,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectResumo, selectMes, selectAno, selectSupervisor) {
        this.selectResumo = selectResumo
        this.selectMes = selectMes
        this.selectAno = selectAno
        this.selectSupervisor = selectSupervisor

        this.dados = []
        this.enableTable = false

        localStorage.setItem('redesSelect', JSON.stringify(this.selectResumo))
        localStorage.setItem('mesSelect', JSON.stringify(this.selectMes))
        localStorage.setItem('anoSelect', this.selectAno)

        this.showTableCoberturaVendedor()
      },

      async showTableCoberturaVendedor () {
        this.loading = true

        await Comercial.showCoberturaVendedor(this.selectResumo, this.selectMes, this.selectAno, this.selectSupervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.enableTable = true

            this.dados = resposta.data.dados.map((item) => {
              var listaMelhoresClientes = ({
                vendedor: item.vendedor,
                cliente: item.cliente.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                positivados: item.positivados.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                porcentagem: item.porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                semCompra: item.semCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.enableTable = false

            this.dados = []

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          eventEmit.$emit('enable-btn-print', true, this.headers, this.dados)

          this.loading = false
        })
      },

      formatCurrency (value) {
        // Função para formatar um valor numérico para moeda brasileira
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
      },
    },
  }
</script>

<style scoped>
  .full-width-table {
    width: 100%;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #linkDetalheAnaliseVendas {
      margin: 0 0 0 13rem
    }

    #idTable {
      max-height: 500px;
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px) {
    .full-width-table {
      width: 100%;
    }
  }
</style>

<style lang="sass">
  #linkDetalheAnaliseVendas
    margin: 0 0 0 42rem
</style>
